import React, {Component} from 'react';
import {Row, Col, Progress, Card, CardTitle, CardHeader, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, Alert} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperGetQuery } from '../../../utils/deviceAPI';

import LoadingIndicator from '../../../utils/LoadingIndicator';
import {Bar, Line, ChartData} from "react-chartjs-2";

import Generator from '../GeneratorSchema/Generator'
import moment from 'moment'
import DeviceOffline from '../DeviceMessages/DeviceOffline';
import Error from '../DeviceMessages/Error';
//daterange
import 'react-dates/initialize';
import { DateRangePicker, isInclusivelyAfterDay, isSame } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import '../../Forms/AdvancedForms/react_dates_overrides.css';
import {isDeviceOnline} from "../../../utils/isDeviceOnline";
import AlarmsList from "./AlarmsList";
import AlarmHistory from "./AlarmHistory";





const Noalarms = () => {
    return <li className="mb-3 mt-3">
        <i className="fa fa-commenting-o bg-info"></i>
        <div className="desc">
            <div className="title">No Alarms are currently present at this site.</div>
        </div>
    </li>
};

const AlarmPopulate = (props) =>  {
    let items = {
        "warning" : "exclamation",
        "danger" : "times",
        "success" : "check",
        "info" : "commenting-o"
    };
    const listItems = props.items.map((alarm,index) => {
            return (
                <li key={index} className="mb-2 mt-2">
                    <i className={"fa fa-" + items[alarm.type] + " bg-" + alarm.type}></i>
                    <div className="desc">
                        <div className="title">{alarm.description}</div>
                        <div className="small text-muted text-uppercase pb-3">{alarm.name}</div>
                    </div>
                </li>
            );
    }
    );
    return (
        <div>
            {listItems}
        </div>
    );
};


class Alarms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {alarms:[]},
            alarmHistory: [],
            loading: true,
            startDate: moment().subtract(7, 'days'),
            endDate: moment(),
            sortColumn:'alarmTriggerd',
            sortDirection:'NONE'

        };


    }
    componentDidMount() {
        this.tick();
        this.timerID = setInterval(
            () => this.tick(),
            6000
        );
        this.getAlarmHistoryData();
    }
    componentWillReceiveProps(nextProps) {
        const dev = this.props.match.params.dev.replace('device_','');
        const newDev = nextProps.match.params.dev.replace('device_','');
        if (dev !== newDev ) {
            this.tick(newDev);
            this.setState({
                loading: true
            }, () => {
                this.getAlarmHistoryData();
            });

        }
    }
    componentWillUnmount(){
        clearInterval(this.timerID);
    }

    tick(device = this.props.match.params.dev.replace('device_','')) {
        ajaxWrapperGet('/api/deviceAlarmsDataAll',device).then((data) => {
            this.setState({
                data,
                loading: false
            });

        });
    }
    getAlarmHistoryData(device = this.props.match.params.dev.replace('device_','')) {
        let startDate = this.state.startDate.format("YYYY-MM-DD");
        let endDate = this.state.endDate.format("YYYY-MM-DD");
        let query = `&startdate=${startDate}&enddate=${endDate}`;
        ajaxWrapperGetQuery('/api/deviceAlarmsHistoryData',device,query).then((alarmHistory) => {
            this.setState({
                alarmHistory,
                loading: false
            });

        });
    }


    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        else if (!isDeviceOnline(this.props.uidata.alarms,this.props.match.params.dev.replace('device_',''))) {
            return (
                <DeviceOffline/>
            )
        }
        const { data } = this.state;
        if (data.error) {
            return <Error message={data.message} type={data.errorType}/>
        }
        const { alarmHistory } = this.state;
        const tomorrow = moment().add(1, 'days');
        const today = moment();
        return (
            <div className="containerAnimation">
                <div className="fadeInUp">
                    <Row>
                        <Col xs="12" md="12" lg="12" xl="12">
                            <Card>
                                <CardBody className="card-body">
                                    <Row className="pb-2">
                                        <Col sm="12">
                                            <CardTitle className="mb-0">Current Alarms</CardTitle>
                                            <div className="small text-muted">view alarms that are currently active.</div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="12">
                                            <hr className="mb-4"/>
                                        </Col>
                                    </Row>
                                    <Row className="pb-2">
                                        <Col sm="12">
                                            <ul className="icons-list mb-5 list-inline">

                                                {data.isAlarmPresent ? "" : <Noalarms />}
                                                <AlarmPopulate items={data.alarms}/>
                                            </ul>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="12" lg="12" xl ="12">
                            <Card>


                                <CardBody className="card-body">
                                    <Row>
                                        <Col sm="5" className="pb-2">
                                            <CardTitle className="mb-0">Historical Alarms</CardTitle>
                                            <div className="small text-muted">view alarms that occured in the past.</div>
                                        </Col>
                                        <Col sm="7" className="d-flex d-sm-inline-block pb-2">
                                            <Button onClick={() => {this.getAlarmHistoryData()}} disabled={this.state.startDate === undefined && this.state.endDate === undefined} color="orange" className="btn float-md-right btn-square">
                                                <i className="fa fa-search" aria-hidden="true"></i>
                                            </Button>
                                            <div className="float-md-right">
                                                <DateRangePicker
                                                    startDate={this.state.startDate}
                                                    startDateId="startDate"
                                                    endDate={this.state.endDate}
                                                    endDateId="endDate"
                                                    onDatesChange={({startDate, endDate}) => this.setState({startDate, endDate})}
                                                    focusedInput={this.state.focusedInput}
                                                    onFocusChange={focusedInput => this.setState({focusedInput})}
                                                    orientation={this.state.orientation}
                                                    openDirection={this.state.openDirection}
                                                    block={false}
                                                    small={true}
                                                    withPortal={true}
                                                    enableOutsideDays={true}
                                                    isOutsideRange={day => isInclusivelyAfterDay(day, tomorrow)}
                                                    isDayHighlighted={day => day.isSame( today, 'd' )}

                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-5">
                                        <Col xs="0" md="2" lg="4" xl="6" className="pr-0 mr-0">
                                        </Col>
                                        <Col xs="6" md="5" lg="4" xl="3" className="pr-0 mr-0">
                                        </Col>
                                        <Col xs="6" md="5" lg="4" xl="1" className="ml-0 pl-0">

                                        </Col>
                                    </Row>
                                    <AlarmHistory rows={alarmHistory} device={this.props.match.params.dev.replace('device_','')}/>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>


                </div>
            </div>


        )
    }
}

export default Alarms;



// WEBPACK FOOTER //
// ./src/views/site/Alarms/Alarms.js